import { Component, OnInit, OnDestroy, ChangeDetectorRef, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup } from '@angular/forms';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';

import { AutoSaveFormBuilder } from '../../pillar/workspace/AutoSaveFormBuilder';
import * as ruleActions from '../store/actions';
import { RuleParameterModel } from '../models/RuleParameterModel';
import { RuleListModel } from '../models/RuleListModel';
import { AlertsComponent } from '../../pillar/alerts/components/alerts.component';
import { AutoSaveFormControl } from '../../pillar/workspace/AutoSaveFormControl';
import { FormControlAutoSaveComponent } from '../../pillar/workspace/components/form-control-auto-save.component';

@Component({
  selector: 'brd-rule-workspace',
  templateUrl: './rule-workspace.component.html',
  styleUrls: ['./rule-workspace.component.scss']
})
export class RuleWorkspaceComponent implements OnInit, OnDestroy {
  destroyed$: Subject<boolean> = new Subject<boolean>();
  profileForm: FormGroup;
  parametersForm: FormGroup;

  editPermission: string = 'RuleModule.BusinessRule:Edit';
  enableDisablePermission: string = 'RuleModule.BusinessRule:EnableDisable';

  @ViewChild(AlertsComponent)
  alerts: AlertsComponent;

  @Input()
  rule: RuleListModel;

  @Output()
  backClicked = new EventEmitter<boolean>();

  constructor(private store: Store<any>,
    private formBuilder: AutoSaveFormBuilder,
    private actions$: Actions,
    private changeDetectorRef: ChangeDetectorRef
    ) {
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  ngOnInit() {
    var ruleListString = sessionStorage.getItem("SelectedRule");
    if (ruleListString) {
      this.rule = JSON.parse(ruleListString);
    }

    this.actions$.ofType(ruleActions.DISABLE_RULE_SUCCESS)
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.alerts.addSuccess('Disable Rule Success');
        this.rule.isEnabled = false;
        sessionStorage.setItem("SelectedRule", JSON.stringify(this.rule));
        this.changeDetectorRef.markForCheck();
      });
  
    this.actions$.ofType(ruleActions.ENABLE_RULE_SUCCESS)
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.alerts.addSuccess('Enable Rule Success');
        this.rule.isEnabled = true;
        sessionStorage.setItem("SelectedRule", JSON.stringify(this.rule));
        this.changeDetectorRef.markForCheck();
      });

    this.actions$.ofType(ruleActions.UPDATE_RULE_PARAMETER_SUCCESS)
      .takeUntil(this.destroyed$)
      .subscribe((a: ruleActions.UpdateRuleParameterSuccessAction) => {
        a.payload.control.saveSuccess(a.payload.parameter);
        var parameter = this.rule.ruleParameters.find(p => p.key === a.payload.parameter.key);
        if (parameter) {
          parameter.value = a.payload.parameter.value;
        }
        this.changeDetectorRef.markForCheck();
      });

    this.initForms();
  }

  initForms(): void {
    this.profileForm = this.formBuilder.group({
      ruleDisplayName: this.formBuilder.control({ value: null, disabled: true },
        Validators.required,
        null,
        this.destroyed$,
        null,
        this.changeDetectorRef)
    });
    this.parametersForm = this.formBuilder.group({
      ruleParameters: this.formBuilder.array(this.rule.ruleParameters.map(() => this.initParameter()))
    });

    this.profileForm.patchValue(this.rule);
    this.profileForm.markAsPristine();
    this.parametersForm.patchValue(this.rule);
    this.parametersForm.markAsPristine();
  }

  initParameter() {
    return this.formBuilder.group({
      key: ['', Validators.required],
      value: this.formBuilder.control('', Validators.required)
    },
      null,
      this.destroyed$,
      (control) => {
        var parameter = control.value as RuleParameterModel;
        parameter.key = control.controls.key.value;
        this.store.dispatch(new ruleActions.UpdateRuleParameterAction({ rule: this.rule, parameter: parameter, control: control }));
      });
  }

  toggleEnabled(rule: RuleListModel) {
    if (!this.rule.isEnabled) {
      this.store.dispatch(new ruleActions.EnableRuleAction({ rule: this.rule }));
    } else {
      this.store.dispatch(new ruleActions.DisableRuleAction({ rule: this.rule }));
    }
  }

  back() {
    this.backClicked.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/components/rule-workspace.component.ts